import tinaPic from "@/public/images/artists/tina.png";
import { Artist } from "@/types/types";

export const tina = {
  id: "106",
  name: "Tina",
  image: tinaPic,
  description: `Tina is a force to be reckoned with, embodying the spirit of soul and disco legends with her powerhouse vocals. Her voice commands attention, effortlessly belting out melodies with unmatched strength and passion.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftina-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Dance", "Disco", "Belting"],
      secondary: ["Singer", "Organic", "Powerhouse", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
